import { createApi } from '@reduxjs/toolkit/query/react';

import { ENVS } from '@/shared/consts';

import { baseQuery } from '../queries/baseQuery';

export const casdoorAuthService = createApi({
  baseQuery: baseQuery({ baseUrl: ENVS.CASDOOR_API_URL, shouldIncludeCredentials: true }),
  tagTypes: [],
  endpoints: () => ({}),
  reducerPath: 'casdoorApi',
});
